export const c_brand_Width = {
  "name": "--pf-v6-c-brand--Width",
  "value": "auto",
  "var": "var(--pf-v6-c-brand--Width)"
};
export default c_brand_Width;